import { MissingDataSource } from 'components/helpers/EditingHelpText';
import Container from 'components/helpers/Container';
import classnames from 'classnames';
import { TcDirectoryListingProps } from '../_types';
import { useCallback, useState } from 'react';
import SurvivorshipProgramComponent from './SurvivorshipProgramComponent';

const SurvivorshipProgramTab = ({ fields }: TcDirectoryListingProps): React.JSX.Element => {
  const [selectedOption, setSelectedOption] = useState<number>(
    fields?.survivorshipPrograms?.length === 1 ? 0 : -1
  );
  const handleChange = useCallback(
    (event: { target: { value: string } }) => {
      setSelectedOption(Number(event.target.value));
    },
    [setSelectedOption]
  );
  // Fail out if we don't have any fields
  if (!fields?.survivorshipPrograms) {
    return <MissingDataSource />;
  }
  // Sort field data
  fields.survivorshipPrograms.sort((a, b) =>
    String(a?.fields?.type?.fields?.Value?.value).localeCompare(
      String(b?.fields?.type?.fields?.Value?.value)
    )
  );

  return (
    <Container size="standard" dataComponent="authorable/nmdpsite/tcdirectory/survivorshipprogram">
      {fields.survivorshipPrograms.length === 0 ? (
        <p>
          No survivorship program information is available. Contact the center for information about
          post-transplant care.
        </p>
      ) : (
        <>
          {fields.survivorshipPrograms.length > 1 && (
            <>
              <div>
                <p className={classnames('pb-2')}>
                  This center has separate survivorship programs for adult and pediatric patients.
                </p>
                <p className={classnames('pb-2')}>
                  Please select the program you are interested in.
                </p>
              </div>
              <select
                value={selectedOption}
                onChange={handleChange}
                className={classnames(
                  'border',
                  'border-gray-spunPearl',
                  'rounded-md',
                  'w-full',
                  'sm:w-1/4',
                  'md:w-1/4',
                  'p-2'
                )}
              >
                <option value="">Select</option>
                {fields.survivorshipPrograms.map((x, index) => (
                  <option
                    value={index}
                    key={x.id}
                    className={classnames('border', 'border-gray-midGray')}
                  >
                    {x?.fields?.type?.fields?.Value?.value === 'Pediatric/Adult'
                      ? 'Pediatric'
                      : x?.fields?.type?.fields?.Value?.value}
                  </option>
                ))}
              </select>
            </>
          )}
          <SurvivorshipProgramComponent {...fields.survivorshipPrograms[selectedOption]} />
        </>
      )}
    </Container>
  );
};
export default SurvivorshipProgramTab;
